import { NotificationTypeEnum } from "./enums"

type sourceSystem = 'Task Management' | 'Sales Order'

export interface NotificationsPayload {
  userId: number,
  type?: NotificationTypeEnum,
  sourceSystem?: sourceSystem,
  limit?: number
}